const dict = {
  uk: {
    title: 'Налаштування',
    language: 'Мова інтерфейсу',
    languageDescription: 'Оберіть мову, якою відображатиметься платформа',
    languageUk: 'Українська',
    languageEn: 'English',
    profileVisible: 'Профіль видимий для інших',
    profileVisibleOn: 'Інші користувачі можуть переглядати ваш профіль',
    profileVisibleOff: 'Ваш профіль прихований від інших',
    changePassword: 'Змінити пароль',
    currentPassword: 'Поточний пароль',
    newPassword: 'Новий пароль',
    confirmPassword: 'Підтвердіть новий пароль',
    savePassword: 'Зберегти пароль',
    passwordMinLength: 'Пароль має містити мінімум 4 символи',
    passwordMismatch: 'Паролі не збігаються',
    telegramTitle: 'Сповіщення в Telegram',
    telegramOn: 'Оплати, нагадування про заняття та домашні дублюються в Telegram',
    telegramOff: 'Отримувати оплати, нагадування та домашні в Telegram',
    telegramDisableError: 'Не вдалося вимкнути. Спробуйте ще раз.',
    telegramEnableError: 'Не вдалося підключити. Спробуйте ще раз.',
    telegramLinkTitle: 'Підключіть Telegram',
    telegramLinkDescription: 'Щоб отримувати сповіщення про оплати, нагадування про заняття та домашні в Telegram, потрібно одноразово підтвердити обліковий запис у нашому боті.',
    telegramLinkStep1: 'Натисніть «Відкрити Telegram» нижче.',
    telegramLinkStep2: 'У боті натисніть кнопку «Start».',
    telegramLinkStep3: 'Поверніться сюди — сповіщення увімкнуться автоматично.',
    telegramLinkWaiting: 'Очікуємо підтвердження...',
    telegramOpen: 'Відкрити Telegram',
    policy: 'Правила та умови',
    deleteProfile: 'Видалити профіль',
    deleteConfirmTitle: 'Видалити профіль?',
    deleteConfirmBody: 'Ви впевнені, що хочете видалити свій профіль? Цю дію неможливо скасувати.',
    deleteConfirmButton: 'Видалити',
    deleteSuccessTitle: 'Успішно',
    deleteSuccessMessage: 'Профіль успішно видалено',
    deleteErrorMessage: 'Помилка видалення профілю',
    passwordChangeError: 'Помилка зміни пароля',
    passwordChangeSuccessTitle: 'Успішно',
    passwordChangeSuccessMessage: 'Пароль успішно змінено',
    connectionError: 'Помилка з\'єднання. Спробуйте пізніше.',
    saveError: 'Помилка збереження',
  },
  en: {
    title: 'Settings',
    language: 'Interface language',
    languageDescription: 'Choose the language for the platform interface',
    languageUk: 'Українська',
    languageEn: 'English',
    profileVisible: 'Profile visible to others',
    profileVisibleOn: 'Other users can view your profile',
    profileVisibleOff: 'Your profile is hidden from others',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    savePassword: 'Save password',
    passwordMinLength: 'Password must be at least 4 characters',
    passwordMismatch: 'Passwords do not match',
    telegramTitle: 'Telegram notifications',
    telegramOn: 'Payments, lesson reminders and homework are mirrored to Telegram',
    telegramOff: 'Receive payments, reminders and homework in Telegram',
    telegramDisableError: 'Could not turn off. Please try again.',
    telegramEnableError: 'Could not connect. Please try again.',
    telegramLinkTitle: 'Connect Telegram',
    telegramLinkDescription: 'To receive notifications about payments, lesson reminders and homework in Telegram, you need to confirm your account in our bot one time.',
    telegramLinkStep1: 'Tap "Open Telegram" below.',
    telegramLinkStep2: 'Press the "Start" button in the bot.',
    telegramLinkStep3: 'Come back here — notifications will turn on automatically.',
    telegramLinkWaiting: 'Waiting for confirmation...',
    telegramOpen: 'Open Telegram',
    policy: 'Terms and conditions',
    deleteProfile: 'Delete profile',
    deleteConfirmTitle: 'Delete profile?',
    deleteConfirmBody: 'Are you sure you want to delete your profile? This action cannot be undone.',
    deleteConfirmButton: 'Delete',
    deleteSuccessTitle: 'Success',
    deleteSuccessMessage: 'Profile deleted successfully',
    deleteErrorMessage: 'Failed to delete profile',
    passwordChangeError: 'Failed to change password',
    passwordChangeSuccessTitle: 'Success',
    passwordChangeSuccessMessage: 'Password changed successfully',
    connectionError: 'Connection error. Please try again later.',
    saveError: 'Failed to save',
  },
};

export default dict;
